import { Component, Input, OnInit } from '@angular/core';
import { QuoteRequestRecipient } from '../../../data/models';

@Component({
    selector: 'app-rfq-response-details',
    templateUrl: './rfq-response-details.component.html',
    styleUrls: ['./rfq-response-details.component.scss'],
    standalone: false,
})
export class RfqResponseDetailsComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() recipient: QuoteRequestRecipient;

    constructor() {}

    ngOnInit(): void {}
}
